export default __webpack_public_path__ + "static/icon-1-5-19db45241fd1717e2af24b87fec39e95.png";